// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-label {
  min-width: 80px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

p {
  display: inline;
}

.time-ion-modal {
  --width: 200px;
  --height: 300px;
}

.fieldItem {
  min-height: 35px;
  --min-height: 35px;
}

.fieldItemReadonly {
  min-height: 35px;
  --min-height: 35px;
}

.fieldtitle {
  min-width: 125px;
  max-width: 125px;
  height: 28px;
  line-height: 15px;
}

.subTitleMax {
  max-width: 300px;
}

.link {
  text-decoration: underline;
  cursor: pointer;
}

.emptyFieldBorderBottom {
  min-height: 10px;
}

.fieldHeight {
  height: 26px;
}

.minwidth {
  min-width: 130px;
}

.inputText {
  border: 2px solid var(--ion-color-medium);
  --border-radius: 0px !important;
  border-radius: 0px !important;
}

.fieldminwidth {
  min-width: 120px;
}

ion-item,
.input-wrapper,
.item-native,
.item-inner {
  background: transparent !important;
  border: 0px !important;
}

ion-input {
  height: 35px;
}

.noBackground {
  background: transparent !important;
}

.fieldDisabled {
  color: #c8c8c8;
}

ion-avatar ion-img {
  max-width: 30px;
  max-height: 30px;
}

.inError {
  color: red;
}

.alertMark {
  font-size: 1rem;
  position: absolute;
  left: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/shaps/components/view-field/view-field.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,mBAAA;EAAqB,gBAAA;EAAkB,uBAAA;AAGzC;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,cAAA;EACA,eAAA;AADF;;AAIA;EAEE,gBAAA;EACA,kBAAA;AAFF;;AAIA;EAEE,gBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,0BAAA;EACA,eAAA;AAFF;;AAMA;EACE,gBAAA;AAHF;;AAOA;EACE,YAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,yCAAA;EACA,+BAAA;EACA,6BAAA;AAJF;;AAQA;EACE,gBAAA;AALF;;AASA;;;;EAIE,kCAAA;EACA,sBAAA;AANF;;AASA;EACE,YAAA;AANF;;AASA;EACE,kCAAA;AANF;;AASA;EACE,cAAA;AANF;;AASA;EACE,eAAA;EACA,gBAAA;AANF;;AASA;EACE,UAAA;AANF;;AASA;EACE,eAAA;EACA,kBAAA;EACA,OAAA;AANF","sourcesContent":["ion-label {\n  min-width: 80px;\n  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;\n}\n\ndiv {\n  //display: inline;\n}\n\np {\n  display: inline;\n}\n\n.time-ion-modal {\n  --width: 200px;\n  --height: 300px;\n}\n\n.fieldItem\n{\n  min-height: 35px;\n  --min-height: 35px;\n}\n.fieldItemReadonly\n{\n  min-height: 35px;\n  --min-height: 35px;\n}\n\n.fieldtitle {\n  min-width: 125px;\n  max-width: 125px;\n  height: 28px;\n  line-height: 15px;\n}\n\n.subTitleMax {\n  max-width: 300px;\n}\n\n.link {\n  text-decoration: underline;\n  cursor: pointer;\n  //color: #ffffff;\n}\n\n.emptyFieldBorderBottom {\n  min-height: 10px;\n  //border-bottom: 1px solid #dfdfdf;\n}\n\n.fieldHeight {\n  height: 26px;\n}\n\n.minwidth {\n  min-width: 130px;\n}\n\n.inputText {\n  border: 2px solid var(--ion-color-medium);\n  --border-radius: 0px !important;\n  border-radius: 0px !important;\n  //max-width: 330px;\n}\n\n.fieldminwidth {\n  min-width: 120px;\n}\n\n\nion-item,\n.input-wrapper,\n.item-native,\n.item-inner {\n  background: transparent !important;\n  border: 0px !important;\n}\n\nion-input {\n  height: 35px;\n}\n\n.noBackground {\n  background: transparent !important;\n}\n\n.fieldDisabled {\n  color: #c8c8c8;\n}\n\nion-avatar ion-img {\n  max-width: 30px;\n  max-height: 30px;\n}\n\n.inError {\n  color: red;\n}\n\n.alertMark {\n  font-size: 1rem;\n  position: absolute;\n  left: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
